import { render, staticRenderFns } from "./ThemeStyleSwitcher.vue?vue&type=template&id=710f4212&scoped=true&"
import script from "./ThemeStyleSwitcher.vue?vue&type=script&lang=js&"
export * from "./ThemeStyleSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710f4212",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VSelect,VSpacer})
